export const servicesList = [
    {
        title: 'разработка по',
        price: 'от 80 000 руб.',
        ico: 'development',
        description: 'Проектирование, создание и внедрение сложных it-проектов, адаптированных под требования отрасли и особенности бизнеса.',
    },
    {
        title: 'автоматизация бизнес-процессов',
        price: 'от 170 000 руб.',
        ico: 'automation',
        description: 'Разработка программ для комплексной и частичной автоматизации бизнес-процессов, создание многофункциональных crm и erp систем.',
    },
    {
        title: 'мобильная разработка',
        price: 'от 180 000 руб.',
        ico: 'mobile',
        description: 'Создание мобильных приложений под платформы ios и android для быстрого доступа к услугам и продукции компании.',
    },
    {
        title: 'интеграция по',
        price: 'от 85 000 руб.',
        ico: 'integration',
        description: 'Гибкое внедрение разработанного по в it-инфраструктуру и организация слаженной работы с корпоративными данными на всех уровнях.',
    },
    {
        title: 'техническая поддержка',
        price: 'от 70 000 руб.',
        ico: 'support',
        description: 'ИТ-сопровождение, устранение ошибок, развитие функционала программного продукта и удалённая поддержка посредством защищённого онлайн-доступа.',
    },
    {
        title: 'доработка имеющегося по',
        price: 'от 75 000 руб.',
        ico: 'rework',
        description: 'Усовершенствование и развитие программных модулей бизнеса любой степени незавершённости, сложности и размера.',
    },
];
